// source: pbtypes/tools/overrides/typed_overrides.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var pbtypes_cloud_services_skyfront_cloud_overrides_pb = require('../../../pbtypes/cloud/services/skyfront/cloud_overrides_pb.js');
goog.object.extend(proto, pbtypes_cloud_services_skyfront_cloud_overrides_pb);
var pbtypes_cloud_services_skygateway_zeppelin_pb = require('../../../pbtypes/cloud/services/skygateway/zeppelin_pb.js');
goog.object.extend(proto, pbtypes_cloud_services_skygateway_zeppelin_pb);
var pbtypes_vehicle_skills_action_key_pb = require('../../../pbtypes/vehicle/skills/action_key_pb.js');
goog.object.extend(proto, pbtypes_vehicle_skills_action_key_pb);
goog.exportSymbol('proto.overrides.FlightPolicyContainer', null, global);
goog.exportSymbol('proto.overrides.GlobalAirspaceDeconflictionOverrides', null, global);
goog.exportSymbol('proto.overrides.RthDeconflictionBandMap', null, global);
goog.exportSymbol('proto.overrides.RthDeconflictionConfig', null, global);
goog.exportSymbol('proto.overrides.TypedOverrides', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.overrides.FlightPolicyContainer = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.overrides.FlightPolicyContainer, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.overrides.FlightPolicyContainer.displayName = 'proto.overrides.FlightPolicyContainer';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.overrides.RthDeconflictionConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.overrides.RthDeconflictionConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.overrides.RthDeconflictionConfig.displayName = 'proto.overrides.RthDeconflictionConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.overrides.RthDeconflictionBandMap = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.overrides.RthDeconflictionBandMap, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.overrides.RthDeconflictionBandMap.displayName = 'proto.overrides.RthDeconflictionBandMap';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.overrides.GlobalAirspaceDeconflictionOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.overrides.GlobalAirspaceDeconflictionOverrides.displayName = 'proto.overrides.GlobalAirspaceDeconflictionOverrides';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.overrides.TypedOverrides = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.overrides.TypedOverrides.repeatedFields_, null);
};
goog.inherits(proto.overrides.TypedOverrides, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.overrides.TypedOverrides.displayName = 'proto.overrides.TypedOverrides';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.overrides.FlightPolicyContainer.prototype.toObject = function(opt_includeInstance) {
  return proto.overrides.FlightPolicyContainer.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.overrides.FlightPolicyContainer} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.FlightPolicyContainer.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: (f = jspb.Message.getBooleanField(msg, 1)) == null ? undefined : f,
videoautorecord: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.overrides.FlightPolicyContainer}
 */
proto.overrides.FlightPolicyContainer.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.overrides.FlightPolicyContainer;
  return proto.overrides.FlightPolicyContainer.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.overrides.FlightPolicyContainer} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.overrides.FlightPolicyContainer}
 */
proto.overrides.FlightPolicyContainer.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setVideoautorecord(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.overrides.FlightPolicyContainer.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.overrides.FlightPolicyContainer.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.overrides.FlightPolicyContainer} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.FlightPolicyContainer.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.overrides.FlightPolicyContainer.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.FlightPolicyContainer} returns this
 */
proto.overrides.FlightPolicyContainer.prototype.setEnabled = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.FlightPolicyContainer} returns this
 */
proto.overrides.FlightPolicyContainer.prototype.clearEnabled = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.FlightPolicyContainer.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool videoAutoRecord = 2;
 * @return {boolean}
 */
proto.overrides.FlightPolicyContainer.prototype.getVideoautorecord = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.FlightPolicyContainer} returns this
 */
proto.overrides.FlightPolicyContainer.prototype.setVideoautorecord = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.FlightPolicyContainer} returns this
 */
proto.overrides.FlightPolicyContainer.prototype.clearVideoautorecord = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.FlightPolicyContainer.prototype.hasVideoautorecord = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.overrides.RthDeconflictionConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.overrides.RthDeconflictionConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.overrides.RthDeconflictionConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.RthDeconflictionConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: (f = jspb.Message.getBooleanField(msg, 1)) == null ? undefined : f,
altitudeBandSize: (f = jspb.Message.getOptionalFloatingPointField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.overrides.RthDeconflictionConfig}
 */
proto.overrides.RthDeconflictionConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.overrides.RthDeconflictionConfig;
  return proto.overrides.RthDeconflictionConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.overrides.RthDeconflictionConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.overrides.RthDeconflictionConfig}
 */
proto.overrides.RthDeconflictionConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAltitudeBandSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.overrides.RthDeconflictionConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.overrides.RthDeconflictionConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.overrides.RthDeconflictionConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.RthDeconflictionConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeFloat(
      4,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.overrides.RthDeconflictionConfig.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.RthDeconflictionConfig} returns this
 */
proto.overrides.RthDeconflictionConfig.prototype.setEnabled = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.RthDeconflictionConfig} returns this
 */
proto.overrides.RthDeconflictionConfig.prototype.clearEnabled = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.RthDeconflictionConfig.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional float altitude_band_size = 4;
 * @return {number}
 */
proto.overrides.RthDeconflictionConfig.prototype.getAltitudeBandSize = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.overrides.RthDeconflictionConfig} returns this
 */
proto.overrides.RthDeconflictionConfig.prototype.setAltitudeBandSize = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.RthDeconflictionConfig} returns this
 */
proto.overrides.RthDeconflictionConfig.prototype.clearAltitudeBandSize = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.RthDeconflictionConfig.prototype.hasAltitudeBandSize = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.overrides.RthDeconflictionBandMap.prototype.toObject = function(opt_includeInstance) {
  return proto.overrides.RthDeconflictionBandMap.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.overrides.RthDeconflictionBandMap} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.RthDeconflictionBandMap.toObject = function(includeInstance, msg) {
  var f, obj = {
vehicleIdToBandMap: (f = msg.getVehicleIdToBandMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.overrides.RthDeconflictionBandMap}
 */
proto.overrides.RthDeconflictionBandMap.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.overrides.RthDeconflictionBandMap;
  return proto.overrides.RthDeconflictionBandMap.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.overrides.RthDeconflictionBandMap} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.overrides.RthDeconflictionBandMap}
 */
proto.overrides.RthDeconflictionBandMap.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = msg.getVehicleIdToBandMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readStringRequireUtf8, jspb.BinaryReader.prototype.readInt32, null, "", 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.overrides.RthDeconflictionBandMap.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.overrides.RthDeconflictionBandMap.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.overrides.RthDeconflictionBandMap} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.RthDeconflictionBandMap.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getVehicleIdToBandMap(true);
  if (f && f.getLength() > 0) {
jspb.internal.public_for_gencode.serializeMapToBinary(
    message.getVehicleIdToBandMap(true),
    1,
    writer,
    jspb.BinaryWriter.prototype.writeString,
    jspb.BinaryWriter.prototype.writeInt32);
  }
};


/**
 * map<string, int32> vehicle_id_to_band = 1;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,number>}
 */
proto.overrides.RthDeconflictionBandMap.prototype.getVehicleIdToBandMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,number>} */ (
      jspb.Message.getMapField(this, 1, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.overrides.RthDeconflictionBandMap} returns this
 */
proto.overrides.RthDeconflictionBandMap.prototype.clearVehicleIdToBandMap = function() {
  this.getVehicleIdToBandMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.overrides.GlobalAirspaceDeconflictionOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.overrides.GlobalAirspaceDeconflictionOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enabled: (f = jspb.Message.getBooleanField(msg, 1)) == null ? undefined : f,
simulatorEnabled: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
handflownEnabled: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
disabled: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.overrides.GlobalAirspaceDeconflictionOverrides;
  return proto.overrides.GlobalAirspaceDeconflictionOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.overrides.GlobalAirspaceDeconflictionOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnabled(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSimulatorEnabled(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHandflownEnabled(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisabled(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.overrides.GlobalAirspaceDeconflictionOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.overrides.GlobalAirspaceDeconflictionOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional bool enabled = 1;
 * @return {boolean}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.getEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides} returns this
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.setEnabled = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides} returns this
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.clearEnabled = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.hasEnabled = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool simulator_enabled = 2;
 * @return {boolean}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.getSimulatorEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides} returns this
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.setSimulatorEnabled = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides} returns this
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.clearSimulatorEnabled = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.hasSimulatorEnabled = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool handflown_enabled = 3;
 * @return {boolean}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.getHandflownEnabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides} returns this
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.setHandflownEnabled = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides} returns this
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.clearHandflownEnabled = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.hasHandflownEnabled = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool disabled = 4;
 * @return {boolean}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.getDisabled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides} returns this
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.setDisabled = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.GlobalAirspaceDeconflictionOverrides} returns this
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.clearDisabled = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.GlobalAirspaceDeconflictionOverrides.prototype.hasDisabled = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.overrides.TypedOverrides.repeatedFields_ = [30];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.overrides.TypedOverrides.prototype.toObject = function(opt_includeInstance) {
  return proto.overrides.TypedOverrides.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.overrides.TypedOverrides} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.TypedOverrides.toObject = function(includeInstance, msg) {
  var f, obj = {
enableOverlayVideo: (f = jspb.Message.getBooleanField(msg, 1)) == null ? undefined : f,
enableOverlayPhoto: (f = jspb.Message.getBooleanField(msg, 2)) == null ? undefined : f,
disableLowResVidLogging: (f = jspb.Message.getBooleanField(msg, 3)) == null ? undefined : f,
disableSoftwareCompatibilityHealthIssues: (f = jspb.Message.getBooleanField(msg, 4)) == null ? undefined : f,
dronesenseMissionSelectionIntegration: (f = jspb.Message.getBooleanField(msg, 5)) == null ? undefined : f,
flightPolicy: (f = msg.getFlightPolicy()) && proto.overrides.FlightPolicyContainer.toObject(includeInstance, f),
flightPolicyNondocked: (f = msg.getFlightPolicyNondocked()) && proto.overrides.FlightPolicyContainer.toObject(includeInstance, f),
disablePropellerAlerts: (f = jspb.Message.getBooleanField(msg, 8)) == null ? undefined : f,
enable5g: (f = jspb.Message.getBooleanField(msg, 9)) == null ? undefined : f,
skyfrontSiteOverrides: (f = msg.getSkyfrontSiteOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteCloudOverrides.toObject(includeInstance, f),
skyfrontDeviceOverrides: (f = msg.getSkyfrontDeviceOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.DeviceCloudOverrides.toObject(includeInstance, f),
rthDeconflictionConfig: (f = msg.getRthDeconflictionConfig()) && proto.overrides.RthDeconflictionConfig.toObject(includeInstance, f),
rthDeconflictionBandMap: (f = msg.getRthDeconflictionBandMap()) && proto.overrides.RthDeconflictionBandMap.toObject(includeInstance, f),
globalAirspaceDeconfliction: (f = msg.getGlobalAirspaceDeconfliction()) && proto.overrides.GlobalAirspaceDeconflictionOverrides.toObject(includeInstance, f),
zeppelinVehicleOverrides: (f = msg.getZeppelinVehicleOverrides()) && pbtypes_cloud_services_skygateway_zeppelin_pb.ZeppelinCloudOverrides.toObject(includeInstance, f),
enableH265Stream: (f = jspb.Message.getBooleanField(msg, 16)) == null ? undefined : f,
preparedApiUrl: (f = jspb.Message.getField(msg, 17)) == null ? undefined : f,
wacsCloudOverrides: (f = msg.getWacsCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.WacsCloudOverrides.toObject(includeInstance, f),
sampleCloudOverrides: (f = msg.getSampleCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides.toObject(includeInstance, f),
rtkCloudOverrides: (f = msg.getRtkCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.RtkCloudOverrides.toObject(includeInstance, f),
siteSecurityCloudOverrides: (f = msg.getSiteSecurityCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteSecurityCloudOverrides.toObject(includeInstance, f),
locationStreamCloudOverrides: (f = msg.getLocationStreamCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.LocationStreamCloudOverrides.toObject(includeInstance, f),
simOrchestratorCloudOverrides: (f = msg.getSimOrchestratorCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.SimOrchestratorCloudOverrides.toObject(includeInstance, f),
sampleGoCloudOverrides: (f = msg.getSampleGoCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides.toObject(includeInstance, f),
videoCaptureCloudOverrides: (f = msg.getVideoCaptureCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.VideoCaptureCloudOverrides.toObject(includeInstance, f),
allowIotControllerFlightOverride: (f = jspb.Message.getBooleanField(msg, 26)) == null ? undefined : f,
showTelemetryToggleUi: (f = jspb.Message.getBooleanField(msg, 27)) == null ? undefined : f,
maxDistanceToDisplayProceedFault: (f = jspb.Message.getField(msg, 28)) == null ? undefined : f,
paraverseScenarioMarkerCloudOverrides: (f = msg.getParaverseScenarioMarkerCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.ParaverseScenarioMarkerCloudOverrides.toObject(includeInstance, f),
allowedInternalActionKeysList: (f = jspb.Message.getRepeatedField(msg, 30)) == null ? undefined : f,
weatherInferenceCloudOverrides: (f = msg.getWeatherInferenceCloudOverrides()) && pbtypes_cloud_services_skyfront_cloud_overrides_pb.WeatherInferenceCloudOverrides.toObject(includeInstance, f),
disableOaDuringDockTakeoff: (f = jspb.Message.getBooleanField(msg, 32)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.overrides.TypedOverrides}
 */
proto.overrides.TypedOverrides.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.overrides.TypedOverrides;
  return proto.overrides.TypedOverrides.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.overrides.TypedOverrides} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.overrides.TypedOverrides}
 */
proto.overrides.TypedOverrides.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableOverlayVideo(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableOverlayPhoto(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableLowResVidLogging(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableSoftwareCompatibilityHealthIssues(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDronesenseMissionSelectionIntegration(value);
      break;
    case 6:
      var value = new proto.overrides.FlightPolicyContainer;
      reader.readMessage(value,proto.overrides.FlightPolicyContainer.deserializeBinaryFromReader);
      msg.setFlightPolicy(value);
      break;
    case 7:
      var value = new proto.overrides.FlightPolicyContainer;
      reader.readMessage(value,proto.overrides.FlightPolicyContainer.deserializeBinaryFromReader);
      msg.setFlightPolicyNondocked(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisablePropellerAlerts(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnable5g(value);
      break;
    case 10:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteCloudOverrides.deserializeBinaryFromReader);
      msg.setSkyfrontSiteOverrides(value);
      break;
    case 11:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.DeviceCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.DeviceCloudOverrides.deserializeBinaryFromReader);
      msg.setSkyfrontDeviceOverrides(value);
      break;
    case 12:
      var value = new proto.overrides.RthDeconflictionConfig;
      reader.readMessage(value,proto.overrides.RthDeconflictionConfig.deserializeBinaryFromReader);
      msg.setRthDeconflictionConfig(value);
      break;
    case 13:
      var value = new proto.overrides.RthDeconflictionBandMap;
      reader.readMessage(value,proto.overrides.RthDeconflictionBandMap.deserializeBinaryFromReader);
      msg.setRthDeconflictionBandMap(value);
      break;
    case 14:
      var value = new proto.overrides.GlobalAirspaceDeconflictionOverrides;
      reader.readMessage(value,proto.overrides.GlobalAirspaceDeconflictionOverrides.deserializeBinaryFromReader);
      msg.setGlobalAirspaceDeconfliction(value);
      break;
    case 15:
      var value = new pbtypes_cloud_services_skygateway_zeppelin_pb.ZeppelinCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skygateway_zeppelin_pb.ZeppelinCloudOverrides.deserializeBinaryFromReader);
      msg.setZeppelinVehicleOverrides(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setEnableH265Stream(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readStringRequireUtf8());
      msg.setPreparedApiUrl(value);
      break;
    case 18:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.WacsCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.WacsCloudOverrides.deserializeBinaryFromReader);
      msg.setWacsCloudOverrides(value);
      break;
    case 19:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides.deserializeBinaryFromReader);
      msg.setSampleCloudOverrides(value);
      break;
    case 20:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.RtkCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.RtkCloudOverrides.deserializeBinaryFromReader);
      msg.setRtkCloudOverrides(value);
      break;
    case 21:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteSecurityCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteSecurityCloudOverrides.deserializeBinaryFromReader);
      msg.setSiteSecurityCloudOverrides(value);
      break;
    case 22:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.LocationStreamCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.LocationStreamCloudOverrides.deserializeBinaryFromReader);
      msg.setLocationStreamCloudOverrides(value);
      break;
    case 23:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.SimOrchestratorCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.SimOrchestratorCloudOverrides.deserializeBinaryFromReader);
      msg.setSimOrchestratorCloudOverrides(value);
      break;
    case 24:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides.deserializeBinaryFromReader);
      msg.setSampleGoCloudOverrides(value);
      break;
    case 25:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.VideoCaptureCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.VideoCaptureCloudOverrides.deserializeBinaryFromReader);
      msg.setVideoCaptureCloudOverrides(value);
      break;
    case 26:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowIotControllerFlightOverride(value);
      break;
    case 27:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setShowTelemetryToggleUi(value);
      break;
    case 28:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMaxDistanceToDisplayProceedFault(value);
      break;
    case 29:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.ParaverseScenarioMarkerCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.ParaverseScenarioMarkerCloudOverrides.deserializeBinaryFromReader);
      msg.setParaverseScenarioMarkerCloudOverrides(value);
      break;
    case 30:
      reader.readPackableEnumInto(msg.getAllowedInternalActionKeysList());
      break;
    case 31:
      var value = new pbtypes_cloud_services_skyfront_cloud_overrides_pb.WeatherInferenceCloudOverrides;
      reader.readMessage(value,pbtypes_cloud_services_skyfront_cloud_overrides_pb.WeatherInferenceCloudOverrides.deserializeBinaryFromReader);
      msg.setWeatherInferenceCloudOverrides(value);
      break;
    case 32:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDisableOaDuringDockTakeoff(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.overrides.TypedOverrides.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.overrides.TypedOverrides.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.overrides.TypedOverrides} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.overrides.TypedOverrides.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = /** @type {boolean} */ (jspb.Message.getField(message, 1));
  if (f != null) {
    writer.writeBool(
      1,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeBool(
      3,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 4));
  if (f != null) {
    writer.writeBool(
      4,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getFlightPolicy();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.overrides.FlightPolicyContainer.serializeBinaryToWriter
    );
  }
  f = message.getFlightPolicyNondocked();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.overrides.FlightPolicyContainer.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 8));
  if (f != null) {
    writer.writeBool(
      8,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 9));
  if (f != null) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getSkyfrontSiteOverrides();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSkyfrontDeviceOverrides();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.DeviceCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getRthDeconflictionConfig();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.overrides.RthDeconflictionConfig.serializeBinaryToWriter
    );
  }
  f = message.getRthDeconflictionBandMap();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      proto.overrides.RthDeconflictionBandMap.serializeBinaryToWriter
    );
  }
  f = message.getGlobalAirspaceDeconfliction();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.overrides.GlobalAirspaceDeconflictionOverrides.serializeBinaryToWriter
    );
  }
  f = message.getZeppelinVehicleOverrides();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      pbtypes_cloud_services_skygateway_zeppelin_pb.ZeppelinCloudOverrides.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 16));
  if (f != null) {
    writer.writeBool(
      16,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 17));
  if (f != null) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getWacsCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      18,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.WacsCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSampleCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      19,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getRtkCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      20,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.RtkCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSiteSecurityCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      21,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteSecurityCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getLocationStreamCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.LocationStreamCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSimOrchestratorCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.SimOrchestratorCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getSampleGoCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getVideoCaptureCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      25,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.VideoCaptureCloudOverrides.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 26));
  if (f != null) {
    writer.writeBool(
      26,
      f
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 27));
  if (f != null) {
    writer.writeBool(
      27,
      f
    );
  }
  f = /** @type {number} */ (jspb.Message.getField(message, 28));
  if (f != null) {
    writer.writeInt32(
      28,
      f
    );
  }
  f = message.getParaverseScenarioMarkerCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      29,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.ParaverseScenarioMarkerCloudOverrides.serializeBinaryToWriter
    );
  }
  f = message.getAllowedInternalActionKeysList();
  if (f.length > 0) {
    writer.writePackedEnum(
      30,
      f
    );
  }
  f = message.getWeatherInferenceCloudOverrides();
  if (f != null) {
    writer.writeMessage(
      31,
      f,
      pbtypes_cloud_services_skyfront_cloud_overrides_pb.WeatherInferenceCloudOverrides.serializeBinaryToWriter
    );
  }
  f = /** @type {boolean} */ (jspb.Message.getField(message, 32));
  if (f != null) {
    writer.writeBool(
      32,
      f
    );
  }
};


/**
 * optional bool enable_overlay_video = 1;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getEnableOverlayVideo = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setEnableOverlayVideo = function(value) {
  return jspb.Message.setField(this, 1, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearEnableOverlayVideo = function() {
  return jspb.Message.setField(this, 1, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasEnableOverlayVideo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool enable_overlay_photo = 2;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getEnableOverlayPhoto = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setEnableOverlayPhoto = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearEnableOverlayPhoto = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasEnableOverlayPhoto = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional bool disable_low_res_vid_logging = 3;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getDisableLowResVidLogging = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setDisableLowResVidLogging = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearDisableLowResVidLogging = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasDisableLowResVidLogging = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool disable_software_compatibility_health_issues = 4;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getDisableSoftwareCompatibilityHealthIssues = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setDisableSoftwareCompatibilityHealthIssues = function(value) {
  return jspb.Message.setField(this, 4, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearDisableSoftwareCompatibilityHealthIssues = function() {
  return jspb.Message.setField(this, 4, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasDisableSoftwareCompatibilityHealthIssues = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool dronesense_mission_selection_integration = 5;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getDronesenseMissionSelectionIntegration = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setDronesenseMissionSelectionIntegration = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearDronesenseMissionSelectionIntegration = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasDronesenseMissionSelectionIntegration = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional FlightPolicyContainer flight_policy = 6;
 * @return {?proto.overrides.FlightPolicyContainer}
 */
proto.overrides.TypedOverrides.prototype.getFlightPolicy = function() {
  return /** @type{?proto.overrides.FlightPolicyContainer} */ (
    jspb.Message.getWrapperField(this, proto.overrides.FlightPolicyContainer, 6));
};


/**
 * @param {?proto.overrides.FlightPolicyContainer|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setFlightPolicy = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearFlightPolicy = function() {
  return this.setFlightPolicy(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasFlightPolicy = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional FlightPolicyContainer flight_policy_nondocked = 7;
 * @return {?proto.overrides.FlightPolicyContainer}
 */
proto.overrides.TypedOverrides.prototype.getFlightPolicyNondocked = function() {
  return /** @type{?proto.overrides.FlightPolicyContainer} */ (
    jspb.Message.getWrapperField(this, proto.overrides.FlightPolicyContainer, 7));
};


/**
 * @param {?proto.overrides.FlightPolicyContainer|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setFlightPolicyNondocked = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearFlightPolicyNondocked = function() {
  return this.setFlightPolicyNondocked(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasFlightPolicyNondocked = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional bool disable_propeller_alerts = 8;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getDisablePropellerAlerts = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setDisablePropellerAlerts = function(value) {
  return jspb.Message.setField(this, 8, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearDisablePropellerAlerts = function() {
  return jspb.Message.setField(this, 8, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasDisablePropellerAlerts = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional bool enable_5g = 9;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getEnable5g = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setEnable5g = function(value) {
  return jspb.Message.setField(this, 9, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearEnable5g = function() {
  return jspb.Message.setField(this, 9, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasEnable5g = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional skyfront.SiteCloudOverrides skyfront_site_overrides = 10;
 * @return {?proto.skyfront.SiteCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getSkyfrontSiteOverrides = function() {
  return /** @type{?proto.skyfront.SiteCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteCloudOverrides, 10));
};


/**
 * @param {?proto.skyfront.SiteCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setSkyfrontSiteOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearSkyfrontSiteOverrides = function() {
  return this.setSkyfrontSiteOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasSkyfrontSiteOverrides = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional skyfront.DeviceCloudOverrides skyfront_device_overrides = 11;
 * @return {?proto.skyfront.DeviceCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getSkyfrontDeviceOverrides = function() {
  return /** @type{?proto.skyfront.DeviceCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.DeviceCloudOverrides, 11));
};


/**
 * @param {?proto.skyfront.DeviceCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setSkyfrontDeviceOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearSkyfrontDeviceOverrides = function() {
  return this.setSkyfrontDeviceOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasSkyfrontDeviceOverrides = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional RthDeconflictionConfig rth_deconfliction_config = 12;
 * @return {?proto.overrides.RthDeconflictionConfig}
 */
proto.overrides.TypedOverrides.prototype.getRthDeconflictionConfig = function() {
  return /** @type{?proto.overrides.RthDeconflictionConfig} */ (
    jspb.Message.getWrapperField(this, proto.overrides.RthDeconflictionConfig, 12));
};


/**
 * @param {?proto.overrides.RthDeconflictionConfig|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setRthDeconflictionConfig = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearRthDeconflictionConfig = function() {
  return this.setRthDeconflictionConfig(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasRthDeconflictionConfig = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional RthDeconflictionBandMap rth_deconfliction_band_map = 13;
 * @return {?proto.overrides.RthDeconflictionBandMap}
 */
proto.overrides.TypedOverrides.prototype.getRthDeconflictionBandMap = function() {
  return /** @type{?proto.overrides.RthDeconflictionBandMap} */ (
    jspb.Message.getWrapperField(this, proto.overrides.RthDeconflictionBandMap, 13));
};


/**
 * @param {?proto.overrides.RthDeconflictionBandMap|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setRthDeconflictionBandMap = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearRthDeconflictionBandMap = function() {
  return this.setRthDeconflictionBandMap(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasRthDeconflictionBandMap = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional GlobalAirspaceDeconflictionOverrides global_airspace_deconfliction = 14;
 * @return {?proto.overrides.GlobalAirspaceDeconflictionOverrides}
 */
proto.overrides.TypedOverrides.prototype.getGlobalAirspaceDeconfliction = function() {
  return /** @type{?proto.overrides.GlobalAirspaceDeconflictionOverrides} */ (
    jspb.Message.getWrapperField(this, proto.overrides.GlobalAirspaceDeconflictionOverrides, 14));
};


/**
 * @param {?proto.overrides.GlobalAirspaceDeconflictionOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setGlobalAirspaceDeconfliction = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearGlobalAirspaceDeconfliction = function() {
  return this.setGlobalAirspaceDeconfliction(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasGlobalAirspaceDeconfliction = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional skygateway.ZeppelinCloudOverrides zeppelin_vehicle_overrides = 15;
 * @return {?proto.skygateway.ZeppelinCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getZeppelinVehicleOverrides = function() {
  return /** @type{?proto.skygateway.ZeppelinCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skygateway_zeppelin_pb.ZeppelinCloudOverrides, 15));
};


/**
 * @param {?proto.skygateway.ZeppelinCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setZeppelinVehicleOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearZeppelinVehicleOverrides = function() {
  return this.setZeppelinVehicleOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasZeppelinVehicleOverrides = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional bool enable_h265_stream = 16;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getEnableH265Stream = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setEnableH265Stream = function(value) {
  return jspb.Message.setField(this, 16, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearEnableH265Stream = function() {
  return jspb.Message.setField(this, 16, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasEnableH265Stream = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional string prepared_api_url = 17;
 * @return {string}
 */
proto.overrides.TypedOverrides.prototype.getPreparedApiUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setPreparedApiUrl = function(value) {
  return jspb.Message.setField(this, 17, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearPreparedApiUrl = function() {
  return jspb.Message.setField(this, 17, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasPreparedApiUrl = function() {
  return jspb.Message.getField(this, 17) != null;
};


/**
 * optional skyfront.WacsCloudOverrides wacs_cloud_overrides = 18;
 * @return {?proto.skyfront.WacsCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getWacsCloudOverrides = function() {
  return /** @type{?proto.skyfront.WacsCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.WacsCloudOverrides, 18));
};


/**
 * @param {?proto.skyfront.WacsCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setWacsCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 18, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearWacsCloudOverrides = function() {
  return this.setWacsCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasWacsCloudOverrides = function() {
  return jspb.Message.getField(this, 18) != null;
};


/**
 * optional skyfront.SampleCloudOverrides sample_cloud_overrides = 19;
 * @return {?proto.skyfront.SampleCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getSampleCloudOverrides = function() {
  return /** @type{?proto.skyfront.SampleCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides, 19));
};


/**
 * @param {?proto.skyfront.SampleCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setSampleCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 19, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearSampleCloudOverrides = function() {
  return this.setSampleCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasSampleCloudOverrides = function() {
  return jspb.Message.getField(this, 19) != null;
};


/**
 * optional skyfront.RtkCloudOverrides rtk_cloud_overrides = 20;
 * @return {?proto.skyfront.RtkCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getRtkCloudOverrides = function() {
  return /** @type{?proto.skyfront.RtkCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.RtkCloudOverrides, 20));
};


/**
 * @param {?proto.skyfront.RtkCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setRtkCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 20, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearRtkCloudOverrides = function() {
  return this.setRtkCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasRtkCloudOverrides = function() {
  return jspb.Message.getField(this, 20) != null;
};


/**
 * optional skyfront.SiteSecurityCloudOverrides site_security_cloud_overrides = 21;
 * @return {?proto.skyfront.SiteSecurityCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getSiteSecurityCloudOverrides = function() {
  return /** @type{?proto.skyfront.SiteSecurityCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.SiteSecurityCloudOverrides, 21));
};


/**
 * @param {?proto.skyfront.SiteSecurityCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setSiteSecurityCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 21, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearSiteSecurityCloudOverrides = function() {
  return this.setSiteSecurityCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasSiteSecurityCloudOverrides = function() {
  return jspb.Message.getField(this, 21) != null;
};


/**
 * optional skyfront.LocationStreamCloudOverrides location_stream_cloud_overrides = 22;
 * @return {?proto.skyfront.LocationStreamCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getLocationStreamCloudOverrides = function() {
  return /** @type{?proto.skyfront.LocationStreamCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.LocationStreamCloudOverrides, 22));
};


/**
 * @param {?proto.skyfront.LocationStreamCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setLocationStreamCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearLocationStreamCloudOverrides = function() {
  return this.setLocationStreamCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasLocationStreamCloudOverrides = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional skyfront.SimOrchestratorCloudOverrides sim_orchestrator_cloud_overrides = 23;
 * @return {?proto.skyfront.SimOrchestratorCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getSimOrchestratorCloudOverrides = function() {
  return /** @type{?proto.skyfront.SimOrchestratorCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.SimOrchestratorCloudOverrides, 23));
};


/**
 * @param {?proto.skyfront.SimOrchestratorCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setSimOrchestratorCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearSimOrchestratorCloudOverrides = function() {
  return this.setSimOrchestratorCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasSimOrchestratorCloudOverrides = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional skyfront.SampleCloudOverrides sample_go_cloud_overrides = 24;
 * @return {?proto.skyfront.SampleCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getSampleGoCloudOverrides = function() {
  return /** @type{?proto.skyfront.SampleCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.SampleCloudOverrides, 24));
};


/**
 * @param {?proto.skyfront.SampleCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setSampleGoCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearSampleGoCloudOverrides = function() {
  return this.setSampleGoCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasSampleGoCloudOverrides = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional skyfront.VideoCaptureCloudOverrides video_capture_cloud_overrides = 25;
 * @return {?proto.skyfront.VideoCaptureCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getVideoCaptureCloudOverrides = function() {
  return /** @type{?proto.skyfront.VideoCaptureCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.VideoCaptureCloudOverrides, 25));
};


/**
 * @param {?proto.skyfront.VideoCaptureCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setVideoCaptureCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 25, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearVideoCaptureCloudOverrides = function() {
  return this.setVideoCaptureCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasVideoCaptureCloudOverrides = function() {
  return jspb.Message.getField(this, 25) != null;
};


/**
 * optional bool allow_iot_controller_flight_override = 26;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getAllowIotControllerFlightOverride = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 26, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setAllowIotControllerFlightOverride = function(value) {
  return jspb.Message.setField(this, 26, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearAllowIotControllerFlightOverride = function() {
  return jspb.Message.setField(this, 26, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasAllowIotControllerFlightOverride = function() {
  return jspb.Message.getField(this, 26) != null;
};


/**
 * optional bool show_telemetry_toggle_ui = 27;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getShowTelemetryToggleUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 27, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setShowTelemetryToggleUi = function(value) {
  return jspb.Message.setField(this, 27, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearShowTelemetryToggleUi = function() {
  return jspb.Message.setField(this, 27, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasShowTelemetryToggleUi = function() {
  return jspb.Message.getField(this, 27) != null;
};


/**
 * optional int32 max_distance_to_display_proceed_fault = 28;
 * @return {number}
 */
proto.overrides.TypedOverrides.prototype.getMaxDistanceToDisplayProceedFault = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 28, 0));
};


/**
 * @param {number} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setMaxDistanceToDisplayProceedFault = function(value) {
  return jspb.Message.setField(this, 28, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearMaxDistanceToDisplayProceedFault = function() {
  return jspb.Message.setField(this, 28, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasMaxDistanceToDisplayProceedFault = function() {
  return jspb.Message.getField(this, 28) != null;
};


/**
 * optional skyfront.ParaverseScenarioMarkerCloudOverrides paraverse_scenario_marker_cloud_overrides = 29;
 * @return {?proto.skyfront.ParaverseScenarioMarkerCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getParaverseScenarioMarkerCloudOverrides = function() {
  return /** @type{?proto.skyfront.ParaverseScenarioMarkerCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.ParaverseScenarioMarkerCloudOverrides, 29));
};


/**
 * @param {?proto.skyfront.ParaverseScenarioMarkerCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setParaverseScenarioMarkerCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 29, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearParaverseScenarioMarkerCloudOverrides = function() {
  return this.setParaverseScenarioMarkerCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasParaverseScenarioMarkerCloudOverrides = function() {
  return jspb.Message.getField(this, 29) != null;
};


/**
 * repeated skills.ActionKey.Enum allowed_internal_action_keys = 30;
 * @return {!Array<!proto.skills.ActionKey.Enum>}
 */
proto.overrides.TypedOverrides.prototype.getAllowedInternalActionKeysList = function() {
  return /** @type {!Array<!proto.skills.ActionKey.Enum>} */ (jspb.Message.getRepeatedField(this, 30));
};


/**
 * @param {!Array<!proto.skills.ActionKey.Enum>} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setAllowedInternalActionKeysList = function(value) {
  return jspb.Message.setField(this, 30, value || []);
};


/**
 * @param {!proto.skills.ActionKey.Enum} value
 * @param {number=} opt_index
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.addAllowedInternalActionKeys = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 30, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearAllowedInternalActionKeysList = function() {
  return this.setAllowedInternalActionKeysList([]);
};


/**
 * optional skyfront.WeatherInferenceCloudOverrides weather_inference_cloud_overrides = 31;
 * @return {?proto.skyfront.WeatherInferenceCloudOverrides}
 */
proto.overrides.TypedOverrides.prototype.getWeatherInferenceCloudOverrides = function() {
  return /** @type{?proto.skyfront.WeatherInferenceCloudOverrides} */ (
    jspb.Message.getWrapperField(this, pbtypes_cloud_services_skyfront_cloud_overrides_pb.WeatherInferenceCloudOverrides, 31));
};


/**
 * @param {?proto.skyfront.WeatherInferenceCloudOverrides|undefined} value
 * @return {!proto.overrides.TypedOverrides} returns this
*/
proto.overrides.TypedOverrides.prototype.setWeatherInferenceCloudOverrides = function(value) {
  return jspb.Message.setWrapperField(this, 31, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearWeatherInferenceCloudOverrides = function() {
  return this.setWeatherInferenceCloudOverrides(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasWeatherInferenceCloudOverrides = function() {
  return jspb.Message.getField(this, 31) != null;
};


/**
 * optional bool disable_oa_during_dock_takeoff = 32;
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.getDisableOaDuringDockTakeoff = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 32, false));
};


/**
 * @param {boolean} value
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.setDisableOaDuringDockTakeoff = function(value) {
  return jspb.Message.setField(this, 32, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.overrides.TypedOverrides} returns this
 */
proto.overrides.TypedOverrides.prototype.clearDisableOaDuringDockTakeoff = function() {
  return jspb.Message.setField(this, 32, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.overrides.TypedOverrides.prototype.hasDisableOaDuringDockTakeoff = function() {
  return jspb.Message.getField(this, 32) != null;
};


goog.object.extend(exports, proto.overrides);
